import { useParams } from "react-router-dom";

import { ClientWebhookContent } from "../components/ClientWebhookContent";
import { WebhookOverviewContent } from "../components/WebhookOverviewContent";

export default function JobSourceWebhooksPage() {
  const { clientId } = useParams<{ clientId?: string }>();
  const isClientContext = Boolean(clientId);

  // For client context, show client-specific webhook content
  // For tenant context, show webhook overview
  if (isClientContext) {
    return <ClientWebhookContent />;
  }

  return <WebhookOverviewContent />;
}
